<ng-template #table>
  <table [attr.aria-label]="'StehtAufFolgendenGrundstuecken' | translate" class="cap-table-detail">
    <thead>
    <tr>
      <th>{{"Nummer" | translate}}</th>
      <th>{{"Art" | translate}}</th>
      <th>{{"Teilflaeche" | translate}}</th>
      <th>{{"Dokumente" | translate}}</th>
      <th>{{"Plan" | translate}}</th>
      <th>{{"Auszug" | translate}}</th>
    </tr>
    </thead>
    <tbody>
      @for (aufGrundstueck of gebAufGrundstueckVM; track aufGrundstueck) {
        <tr>
          <td>
            @if (aufGrundstueck.model.grundstueck) {
              <cap-kompakt-grundstueck [capHistinfo]="aufGrundstueck.model.histInfo"
                                       [item]="aufGrundstueck.model.grundstueck">
              </cap-kompakt-grundstueck>
            }
            <cap-kompakt-timepoint [item]="aufGrundstueck.model.grundstueck.histInfo?.bisTimePoint"
                                   loeschgeschaeft></cap-kompakt-timepoint>
          </td>
          @if (aufGrundstueck.model.grundstueck) {
            <td [capHistinfo]="aufGrundstueck.model.histInfo">
              <cap-link
                [queryParams]="{ id: aufGrundstueck.model.grundstueck.id.id }"
                [target]="navTargets.NAV_GRUNDSTUECK"
                [tooltipParams]="{ nummer: aufGrundstueck.model.grundstueck?.grundstueckNummer | grundstuecknummerExtended }">
                @if (aufGrundstueck.model.grundstueck?.grundstueckArt === "SDR") {
                  <span>
                    {{ "SelbstständigesUndDauerndesRecht" | translate }}
                  </span>
                }
                @if (aufGrundstueck.model.grundstueck?.grundstueckArt != "SDR") {
                  <span>
                    {{ aufGrundstueck.model.grundstueck?.grundstueckArt | translate }}
                  </span>
                }
              </cap-link>
            </td>
          }
          <td>
            @if (aufGrundstueck.model.flaecheQuadratmeter) {
              <span [capHistinfo]="aufGrundstueck.model.histInfo">
                <cap-link
                  [queryParams]="{ id: aufGrundstueck.model.grundstueck.id.id }"
                  [target]="navTargets.NAV_GRUNDSTUECK"
                  [tooltipParams]="{ nummer: aufGrundstueck.model.grundstueck?.grundstueckNummer | grundstuecknummerExtended }">
                  {{ aufGrundstueck.model.flaecheQuadratmeter | decimalHochkomma }}&nbsp;m²
                </cap-link>
              </span>
            }
            <cap-kompakt-timepoint [item]="aufGrundstueck.model.histInfo?.bisTimePoint"
                                   loeschgeschaeft></cap-kompakt-timepoint>
          </td>
          <td>
            @if (aufGrundstueck.model.grundstueck.grundstueckArt != "UNBEKANNT" && appformatConfigService.settingsConfig$ | async; as settingsConfig) {
              @if (settingsConfig.isCmisConfigured && aufGrundstueck.model?.id) {
                <cap-cmis
                  [target]="{ itemType: 'Grundstueck', id: aufGrundstueck.model?.id.id, tooltipParam: aufGrundstueck.model.grundstueck.grundstueckNummer | grundstuecknummerExtended }"></cap-cmis>
              } @else {
                <cap-dokulink
                  [item]="dokuLinkBuilderFactory.create('GRUNDSTUECK').setEntry(aufGrundstueck.model.grundstueck).build()"></cap-dokulink>
              }
            }
          </td>
          <td>
            <cap-maps
              [mapType]="'grundstueck'"
              [model]="aufGrundstueck.model.grundstueck"
              [tooltip]="aufGrundstueck.model.grundstueck.grundstueckArt | translate"></cap-maps>
          </td>
          <td>
            <cap-auszug [item]="aufGrundstueck.model.grundstueck"></cap-auszug>
          </td>
        </tr>
      }
    </tbody>
  </table>
</ng-template>

@if (gebAufGrundstueckVM.length == 0) {
  <ng-template [ngTemplateOutlet]="keine"></ng-template>
} @else {
  <table [attr.aria-label]="'StehtAufFolgendenGrundstuecken' | translate" class="cap-table-detail">
    <thead>
    <tr>
      <th>{{"Nummer" | translate}}</th>
      <th>{{"Art" | translate}}</th>
      <th>{{"Teilflaeche" | translate}}</th>
      <th>{{"Dokumente" | translate}}</th>
      <th>{{"Plan" | translate}}</th>
      <th>{{"Auszug" | translate}}</th>
    </tr>
    </thead>
    <tbody>
      @for (aufGrundstueck of gebAufGrundstueckVM; track aufGrundstueck) {
        <tr>
          <td>
            @if (aufGrundstueck.model.grundstueck) {
              <cap-kompakt-grundstueck [capHistinfo]="aufGrundstueck.model.histInfo"
                                       [item]="aufGrundstueck.model.grundstueck">
              </cap-kompakt-grundstueck>
            }
            <cap-kompakt-timepoint [item]="aufGrundstueck.model.grundstueck.histInfo?.bisTimePoint"
                                   loeschgeschaeft></cap-kompakt-timepoint>
          </td>
          @if (aufGrundstueck.model.grundstueck) {
            <td [capHistinfo]="aufGrundstueck.model.histInfo">
              <cap-link
                [queryParams]="{ id: aufGrundstueck.model.grundstueck.id.id }"
                [target]="navTargets.NAV_GRUNDSTUECK"
                [tooltipParams]="{ nummer: aufGrundstueck.model.grundstueck?.grundstueckNummer | grundstuecknummerExtended }">
                @if (aufGrundstueck.model.grundstueck?.grundstueckArt === "SDR") {
                  <span>
                    {{ "SelbstständigesUndDauerndesRecht" | translate }}
                  </span>
                }
                @if (aufGrundstueck.model.grundstueck?.grundstueckArt != "SDR") {
                  <span>
                    {{ aufGrundstueck.model.grundstueck?.grundstueckArt | translate }}
                  </span>
                }
              </cap-link>
            </td>
          }
          <td>
            @if (aufGrundstueck.model.flaecheQuadratmeter) {
              <span [capHistinfo]="aufGrundstueck.model.histInfo">
                <cap-link
                  [queryParams]="{ id: aufGrundstueck.model.grundstueck.id.id }"
                  [target]="navTargets.NAV_GRUNDSTUECK"
                  [tooltipParams]="{ nummer: aufGrundstueck.model.grundstueck?.grundstueckNummer | grundstuecknummerExtended }">
                  {{ aufGrundstueck.model.flaecheQuadratmeter | decimalHochkomma }}&nbsp;m²
                </cap-link>
              </span>
            }
            <cap-kompakt-timepoint [item]="aufGrundstueck.model.histInfo?.bisTimePoint"
                                   loeschgeschaeft></cap-kompakt-timepoint>
          </td>
          <td>
            @if (aufGrundstueck.model.grundstueck.grundstueckArt != "UNBEKANNT" && appformatConfigService.settingsConfig$ | async; as settingsConfig) {
              @if (settingsConfig.isCmisConfigured && aufGrundstueck.model?.id) {
                <cap-cmis
                  [target]="{ itemType: 'Grundstueck', id: aufGrundstueck.model?.id.id, tooltipParam: aufGrundstueck.model?.grundstueck.grundstueckNummer | grundstuecknummerExtended }"></cap-cmis>
              } @else {
                <cap-dokulink
                  [item]="dokuLinkBuilderFactory.create('GRUNDSTUECK').setEntry(aufGrundstueck.model.grundstueck).build()"></cap-dokulink>
              }
            }
          </td>
          <td>
            <cap-maps
              [mapType]="'grundstueck'"
              [model]="aufGrundstueck.model.grundstueck"
              [tooltip]="aufGrundstueck.model.grundstueck.grundstueckArt | translate"></cap-maps>
          </td>
          <td>
            <cap-auszug [item]="aufGrundstueck.model.grundstueck"></cap-auszug>
          </td>
        </tr>
      }
    </tbody>
  </table>
}
<ng-template #keine>
  <div class="mb-2">
    <span>{{"Keine" | translate}}</span>
  </div>
</ng-template>
